export const GenderNumber: { [key: string]: string } = {
  0: 'Nữ',
  1: 'Nam',
};
export const genderNumberOptions = [
  {
    label: 'Nữ',
    value: 0,
  },
  {
    label: 'Nam',
    value: 1,
  },
];

export enum Gender {
  Male = 'male',
  Female = 'female',
}

export const genderOptions = [
  {
    label: 'Nam',
    value: Gender.Male,
  },
  {
    label: 'Nữ',
    value: Gender.Female,
  },
];

export type Bank = {
  code: string;
  name: string;
  shortName: string;
};

export * from './promotion';
export * from './identity';
